import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const OrderConfirmed = () => {
  const [orderData, setOrderData] = useState({
    orderNumber: "",
    orderDate: "",
    deliveryDate: "",
    items: [],
    subtotal: 0,
    tax: 0,
    shipping: 0,
    total: 0,
    user: {
      name: "",
      email: "",
      phone: "",
      address: "",
    },
  });

  useEffect(() => {
    const cart = JSON.parse(sessionStorage.getItem("lastOrder")) || [];

    const subtotal = Number(sessionStorage.getItem("orderSubtotal")) || 0;
    const tax = Number(sessionStorage.getItem("orderTax")) || 0;
    const shipping = Number(sessionStorage.getItem("orderShipping")) || 0;
    const total = Number(sessionStorage.getItem("orderTotal")) || 0;

    const email =
      sessionStorage.getItem("email") ||
      sessionStorage.getItem("userEmail") ||
      "user@example.com";

    const firstName = sessionStorage.getItem("firstName") || "";
    const lastName = sessionStorage.getItem("lastName") || "";

    const phone = sessionStorage.getItem("phone") || "+15053778663";
    const address =
      sessionStorage.getItem("address") ||
      "1st Floor, 41 Rampuri Kalkaji, Huntsville, AL 110019";

    const today = new Date();
    const orderDate = today.toLocaleDateString();
    const deliveryDate = new Date(
      today.setDate(today.getDate() + 7)
    ).toLocaleDateString();

    setOrderData({
      orderNumber: Math.floor(Math.random() * 90000) + 10000,
      orderDate,
      deliveryDate,
      items: cart,
      subtotal,
      tax,
      shipping,
      total,
      user: {
        name: `${firstName} ${lastName}`.trim(),
        email,
        phone,
        address,
      },
    });

    // Cleanup cart after loaded
    setTimeout(() => sessionStorage.removeItem("lastOrder"), 2000);
  }, []);

  const {
    orderNumber,
    orderDate,
    deliveryDate,
    items,
    subtotal,
    tax,
    shipping,
    total,
    user,
  } = orderData;

  const handleDownloadInvoice = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Invoice", 14, 20);

    autoTable(doc, {
      startY: 30,
      head: [["Order #", "Date", "Total"]],
      body: [[orderNumber, orderDate, `$${total.toFixed(2)}`]],
    });

    doc.save(`Invoice_${orderNumber}.pdf`);
  };

  return (
    <section style={{ background: "#f6f7fb", padding: "70px 0" }}>
      <div className="container" style={{ maxWidth: "850px" }}>
        {/* Success Icon */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <div
            style={{
              width: "95px",
              height: "95px",
              borderRadius: "50%",
              background: "#4caf50",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 auto 15px",
              boxShadow: "0 6px 25px rgba(76,175,80,.25)",
            }}
          >
            <i
              className="ph ph-check"
              style={{ color: "white", fontSize: "48px" }}
            ></i>
          </div>

          <h2 style={{ fontWeight: 700, fontSize: "28px" }}>Order Confirmed</h2>
          <p style={{ color: "#666" }}>
            Thank you! Your order has been successfully placed.
          </p>
          <h4 style={{ marginTop: "10px", fontSize: "18px" }}>
            Order #{orderNumber}
          </h4>
        </div>

        {/* Order Summary */}
        <div
          style={{
            background: "white",
            padding: "30px",
            borderRadius: "14px",
            marginBottom: "25px",
            boxShadow: "0px 6px 20px rgba(0,0,0,0.05)",
          }}
        >
          <h4>Order Details</h4>
          <p>Order Date: {orderDate}</p>
          <p>Est. Delivery: {deliveryDate}</p>
          <p>
            Total: <strong>${total.toFixed(2)}</strong>
          </p>
        </div>

        {/* Items */}
        <div
          style={{
            background: "white",
            padding: "30px",
            borderRadius: "14px",
            marginBottom: "25px",
            boxShadow: "0px 6px 20px rgba(0,0,0,0.05)",
          }}
        >
          <h4>Items Ordered</h4>

          {items.map((item, i) => (
            <div
              key={i}
              style={{
                padding: "12px 0",
                borderBottom: i < items.length - 1 ? "1px solid #eee" : "none",
              }}
            >
              <div style={{ fontWeight: 600 }}>{item.name}</div>
              <div style={{ fontSize: "14px", color: "#888" }}>
                Qty: {item.quantity || 1}
              </div>
              <div style={{ marginTop: "6px", fontWeight: 600 }}>
                ${(item.price * (item.quantity || 1)).toFixed(2)}
              </div>
            </div>
          ))}
        </div>

        {/* Customer Info */}
        <div
          style={{
            background: "white",
            padding: "30px",
            borderRadius: "14px",
            marginBottom: "30px",
            boxShadow: "0px 6px 20px rgba(0,0,0,0.05)",
          }}
        >
          <h4>Shipping Information</h4>
          <p style={{ marginTop: "10px" }}>{user.name}</p>
          <p>{user.email}</p>
          <p>{user.phone}</p>
          <p>{user.address}</p>
        </div>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            gap: "15px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <button
            onClick={handleDownloadInvoice}
            style={{
              background: "#111",
              color: "white",
              padding: "14px 25px",
              borderRadius: "50px",
              border: "none",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Download Invoice
          </button>

          <Link
            to="/order-track"
            style={{
              background: "#4caf50",
              color: "white",
              padding: "14px 25px",
              borderRadius: "50px",
              fontWeight: 600,
            }}
          >
            Track Order
          </Link>

          <a
            href="tel:+1-786-761-8824"
            style={{
              border: "2px solid #111",
              padding: "14px 25px",
              borderRadius: "50px",
              fontWeight: 600,
              color: "#111",
            }}
          >
            Call Support: +1-786-761-8824
          </a>
        </div>
      </div>
    </section>
  );
};

export default OrderConfirmed;
